import React from 'react';
import AutoSuggest from 'react-autosuggest';
import TagsInput from 'react-tagsinput';
import themeStyles from '../InputSuggest/InputSuggest.css';
// eslint-disable-next-line import/no-unresolved,import/no-webpack-loader-syntax
import '!style-loader!css-loader!./InputTagsSuggest.css';

class InputTagsSuggest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // list of suggestions shown to the user.
      filteredSuggestions: [],
      // used to dedup the filtered suggestions list
      taggedSuggestions: props.suggestions || [],
      tags: [],
      tag: '',
    };
    this.autoSuggestInput = null;
  }

  componentDidMount() {
    const { input } = this.props;
    this.setupState(input.value);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.input.value !== this.props.input.value) {
      this.setupState(this.props.input.value);
    }
    if (prevProps.suggestions !== this.props.suggestions) {
      this.updateTaggedSuggestion(this.state.tags);
    }
  }

  setupState(value) {
    const { delimiter, maxTags } = this.props;
    if (value !== '') {
      let tags = value.split(delimiter || '|').map(d => d.trim());
      if (tags.length > maxTags) {
        tags = [value];
      }
      this.setState({
        tags,
        taggedSuggestions: this.filterSuggestionsByTagged(tags),
      });
    }
  }

  /**
   * Called every time the input value changes
   * @param value
   * @param reason
   */
  handleFetch = ({ value, reason }) => {
    const { taggedSuggestions } = this.state;
    const { filterSuggestion } = this.props;
    if (reason === 'input-changed') {
      // Get the list of suggestions for the user to pick from
      const filteredSuggestions = filterSuggestion(value, taggedSuggestions);
      this.setState({ filteredSuggestions });
    }
  };

  handleClear = () => {
    this.setState({ filteredSuggestions: [] });
  };

  handleOnChangeInput = tag => {
    const delimiter = this.props.delimiter || '|';
    const regEx = new RegExp(`\\${delimiter}`, 'g');
    const scrubbed = typeof tag === 'string' ? tag.replace(regEx, '') : '';
    this.setState({
      // strip out delimiter
      tag: scrubbed,
    });
  };

  handleTagsChange = tags => {
    const { input, delimiter } = this.props;
    const wasTagsCleared = tags.length < this.state.tags.length;
    this.setState(
      {
        tags,
        taggedSuggestions: this.filterSuggestionsByTagged(tags),
      },
      () => {
        // save to form field
        const inputValue = tags.join(delimiter || '|');
        input.onChange(inputValue);
        // handle tag being cleared
        if (wasTagsCleared && typeof this.props.onRemoveTag === 'function') {
          this.props.onRemoveTag(inputValue);
        }
      },
    );
  };

  onTagInputClick = e => {
    e.preventDefault();
    if (this.autoSuggestInput && e.target && e.target.tagName !== 'INPUT') {
      this.autoSuggestInput.focus();
    }
  };

  handlePasteSplit = data => {
    const { delimiter } = this.props;
    return data.split(delimiter || '|').map(d => d.trim());
  };

  updateTaggedSuggestion = tags => {
    this.setState({
      taggedSuggestions: this.filterSuggestionsByTagged(tags),
    });
  };

  filterSuggestionsByTagged(tags) {
    const { suggestions, filterSuggestion } = this.props;
    let taggedSuggestions = suggestions || [];
    tags.forEach(tag => {
      const taggedItem = filterSuggestion(tag, taggedSuggestions);
      taggedSuggestions = taggedSuggestions.filter(
        item => item !== taggedItem[0], // only out first match
      );
    });
    return taggedSuggestions;
  }

  renderAutoSuggestInput = ({ addTag, ...props }) => {
    const {
      getSuggestionValue,
      renderSuggestion,
      theme = themeStyles || {},
      placeholder,
      maxTags,
    } = this.props;
    const { tags } = this.state;
    const hasMaxTags = maxTags && maxTags === tags.length;
    const placeHolderText = hasMaxTags ? '' : placeholder;
    const { filteredSuggestions } = this.state;
    const handleOnChange = (e, { method }) => {
      if (method === 'enter') {
        // menu item selected event.
        e.preventDefault();
      } else if (!hasMaxTags) {
        // props is TagsInput props
        props.onChange(e);
      }
    };
    const handleKeyDown = e => {
      // menu item selection event.
      if (e.target.value !== '' || e.keyCode === 8) {
        // props is TagsInput props
        props.onKeyDown(e);
      }
    };
    const handleSuggestionSelected = (e, { suggestionValue }) => {
      addTag(suggestionValue);
    };

    return (
      <AutoSuggest
        ref={autoSuggest => {
          if (autoSuggest !== null) {
            this.autoSuggestInput = autoSuggest.input;
          }
        }}
        suggestions={filteredSuggestions}
        onSuggestionsFetchRequested={this.handleFetch}
        onSuggestionsClearRequested={this.handleClear}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        onSuggestionSelected={handleSuggestionSelected}
        theme={theme}
        inputProps={{
          ...props,
          onChange: handleOnChange,
          placeholder: placeHolderText,
          onKeyDown: handleKeyDown,
          autoFocus: true,
        }}
      />
    );
  };

  render() {
    const {
      className = themeStyles.inputSuggestContainer,
      maxTags = undefined,
      renderTag = undefined,
    } = this.props;
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      <div className={className} onClick={this.onTagInputClick}>
        <TagsInput
          renderInput={this.renderAutoSuggestInput}
          value={this.state.tags}
          onChange={this.handleTagsChange}
          onlyUnique
          addOnBlur
          addOnPaste
          pasteSplit={this.handlePasteSplit}
          // validationRegex={/^[^|]*$/}
          inputValue={this.state.tag}
          onChangeInput={this.handleOnChangeInput}
          maxTags={maxTags}
          renderTag={renderTag}
        />
      </div>
    );
  }
}
export default InputTagsSuggest;



// WEBPACK FOOTER //
// ./src/views/containers/InputTagsSuggest/InputTagsSuggest.jsx